import { api } from "@/client/api";
import { configs } from "@/configs";

export async function sendPasswordResetEmail(email: string) {
  await api.post<string>(`${configs.apiUrl}/auth/reset-password`, {
    email,
  });
}
